var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FillPage',{attrs:{"type":"1","tip":"啊哦，你所访问的页面不存在","back-link":""}})}
var staticRenderFns = []

export { render, staticRenderFns }